"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var _processSmallCaps = _interopRequireDefault(require("./processSmallCaps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getFontUnitsPerEm = R.path(['font', 'unitsPerEm']);
var getFontDescent = R.path(['font', 'descent']);
var getFontAscent = R.path(['font', 'ascent']);
var getAvailableFontFeatures = R.path(['availableFeatures']);
var isFontFeatureExist = function isFontFeatureExist(font, feature) {
  var availableFontFeatures = getAvailableFontFeatures(font);
  if (!availableFontFeatures) return false;
  return availableFontFeatures.includes(feature);
};
var getFontFeatureTag = function getFontFeatureTag(feature) {
  switch (feature) {
    case 'small-caps':
      return 'smcp';
    default:
      return null;
  }
};
var calculateSizeAndScale = function calculateSizeAndScale(run) {
  var _run$attributes = run.attributes,
    attributes = _run$attributes === void 0 ? {} : _run$attributes;
  var baseFontSize = attributes.fontSize,
    fontVariant = attributes.fontVariant,
    baseScale = attributes.scale,
    baseYOffset = attributes.yOffset,
    font = attributes.font;
  var fontUnitsPerEm = getFontUnitsPerEm(attributes);
  var fontSize = baseFontSize;
  var scale = baseScale;
  var yOffset = baseYOffset;
  if (['superscript', 'subscript'].includes(fontVariant)) {
    fontSize = baseFontSize * 75 / 100;
  }
  if (['small-caps'].includes(fontVariant) && !isFontFeatureExist(font, getFontFeatureTag(fontVariant))) {
    fontSize = baseFontSize * 75 / 100;
  }
  scale = fontSize / fontUnitsPerEm;
  var fontAscent = getFontAscent(attributes);
  var fontDescent = getFontDescent(attributes);
  if (fontVariant === 'superscript') {
    var _YOffset = fontAscent * 50 / (100 * fontUnitsPerEm);
    if (fontUnitsPerEm >= 2000) {
      _YOffset = fontAscent * 30 / (100 * fontUnitsPerEm);
    }
    yOffset += _YOffset;
  }
  if (fontVariant === 'subscript') {
    yOffset += fontDescent * 80 / (200 * fontUnitsPerEm);
  }
  return (0, _extends2.default)({}, run, {
    attributes: (0, _extends2.default)({}, attributes, {
      fontSize: fontSize,
      scale: scale,
      yOffset: yOffset
    })
  });
};

/**
 * Calculate font size and scale according to font varients
 *
 * @param  {Object}   layout engines
 * @param  {Array}    attributed strings
 * @return {Array}    attributed string with resolved font sizes and scales
 */
var resolveTextStyles = function resolveTextStyles() {
  return function (attributedString) {
    return R.compose(R.evolve({
      runs: R.map(calculateSizeAndScale)
    }), _processSmallCaps.default)(attributedString);
  };
};
var _default = exports.default = resolveTextStyles;